import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  grid: {
    display: 'block',
    whiteSpace: 'pre-wrap',
  },
}));
